import React, {Fragment}  from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import strip from "striptags";

export default function Siblings() {
    
    let app = ApplicantContainer.useContainer();

    let siblingStudy = app.inStdValues.frSiblingStudy;
    let siblingWorking = app.inStdValues.frSiblingWorking;

    const addSiblingStudy = index => {    

        const values = [...siblingStudy];
        values.splice(index+1, 0, {SiblingName: '', Gender: '', Age: '', NameOfSchool: '', SrcFinSupport: '' });
        app.onChangeInStdValues({...app.inStdValues, frSiblingStudy:values});
    }

    const delSiblingStudy = index => {    

        if(siblingStudy.length === 1) return 0;

        const values = [...siblingStudy];    
        values.splice(index, 1);
        app.onChangeInStdValues({...app.inStdValues, frSiblingStudy:values});
    }

    const handleInputChangeStudy = (inputname, index, event) => {      
      
      if((' frAgeSiblingStudy').search(event.target.name) > 0)
      event.target.value = event.target.value.replace(/\D/g,'');

      event.target.value = strip(event.target.value);

        const values = [...siblingStudy];  
        
        values[index].[inputname] = event.target.value;     
        app.onChangeInStdValues({...app.inStdValues, frSiblingStudy:values});
    };


  const addSiblingWorking = index => {    

      const values = [...siblingWorking];
      values.splice(index+1, 0, {SiblingName: '', Gender: '', Age: '', Occupation: '', Income: '' });
      app.onChangeInStdValues({...app.inStdValues, frSiblingWorking:values});
  }

  const delSiblingWorking = index => {    

      if(siblingWorking.length === 1) return 0;

      const values = [...siblingWorking];    
      values.splice(index, 1);
      app.onChangeInStdValues({...app.inStdValues, frSiblingWorking:values});
  }

  const handleInputChangeWorking = (inputname, index, event) => {        

    if((' frAgeSiblingWorking frIncomeSiblingWorking').search(event.target.name) > 0)
    event.target.value = event.target.value.replace(/\D/g,'');
    
    event.target.value = strip(event.target.value);

      const values = [...siblingWorking];        

      values[index].[inputname] = event.target.value;    
      
      app.onChangeInStdValues({...app.inStdValues, frSiblingWorking:values});
  };

    return (    
    <>
    <Form.Row>
    <Col xs={12}>
        
        <Form.Group as={Col} controlId="formName">
        <Form.Label className="h6">Siblings' or other dependents' details</Form.Label>
        </Form.Group>
    </Col>  
    </Form.Row>

    <div className="border p-1 m-2 mb-3">
    <Form.Row>
    <Col xs={12}>        
        <Form.Group as={Col} controlId="formName">
        <Form.Label >If studying</Form.Label>
        </Form.Group>
    </Col>  
    </Form.Row>

    <Form.Row className="p-2 Siblings">
    <Col xs={12}>

      <Form.Row className="d-none d-md-flex">
      <Col xs={12} sm={4} className='table-header'>
        <Form.Group as={Col}>
        <Form.Label>Name</Form.Label>
        </Form.Group>
      </Col>
      <Col xs={12} sm={1} className='table-header'>
        <Form.Group as={Col}>
        <Form.Label>Gender</Form.Label>
        </Form.Group>
      </Col>
      <Col xs={12} sm={1} className='table-header'>
        <Form.Group as={Col}>
          <Form.Label>Age</Form.Label>
        </Form.Group>
      </Col>
      <Col xs={12} sm={2} className='table-header'>
        <Form.Group as={Col}>
          <Form.Label>Name of School / Institution</Form.Label>
        </Form.Group>
      </Col>
      <Col xs={12} sm={2} className='table-header'>
        <Form.Group as={Col}>
          <Form.Label>Source of Financial Support</Form.Label>
        </Form.Group>
      </Col>
      <Col xs={12} sm={2} className='table-header d-flex justify-content-center'>          
        <Form.Group as={Col} className="segbutton">
          <Form.Label>action</Form.Label>
      </Form.Group>
      </Col>        
    </Form.Row> 

        {siblingStudy.map((inputField, index) => (
        <Fragment key={`${inputField}~${index}`}>
        <Form.Row>          
        <Col xs={12} md={4}>
          <Form.Group as={Col} >
            <Form.Label className="d-flex d-md-none">SiblingName</Form.Label>
            <Form.Control name="frNameSiblingStudy" type="text" placeholder="" value={inputField.SiblingName} onChange={event => handleInputChangeStudy('SiblingName', index, event)} />
          </Form.Group>
        </Col>
        <Col xs={12} md={1}>              
          <Form.Group as={Col} >
            <Form.Label className="d-flex d-md-none">Gender</Form.Label>
              <Form.Control name="frGenderSiblingStudy" as="select"   
                value={inputField.Gender}
                onChange={(event) => handleInputChangeStudy('Gender', index, event)} >
                <option key='' value=''></option>  
                <option key='M' value='M'>M</option>
                <option key='F' value='F'>F</option>            
              </Form.Control>
          </Form.Group>
        </Col>
        <Col xs={12} md={1}>
          <Form.Group as={Col} >
            <Form.Label className="d-flex d-md-none">Age</Form.Label>  
            <Form.Control name="frAgeSiblingStudy" type="text" placeholder="" value={inputField.Age} onChange={event => handleInputChangeStudy('Age', index, event)} />
          </Form.Group>  
        </Col>
        <Col xs={12} md={2}>
          <Form.Group as={Col} >
            <Form.Label className="d-flex d-md-none">Name of School / Institution</Form.Label>
            <Form.Control name="frSchoolSiblingStudy" type="text" placeholder="" value={inputField.NameOfSchool} onChange={event => handleInputChangeStudy('NameOfSchool', index, event)} />
          </Form.Group>
        </Col>
        <Col xs={12} md={2}>
          <Form.Group as={Col} >
            <Form.Label className="d-flex d-md-none">Source of Financial Support</Form.Label>
            <Form.Control name="frFinancialSiblingStudy" type="text" placeholder="" value={inputField.SrcFinSupport} onChange={event => handleInputChangeStudy('SrcFinSupport', index, event)} />
          </Form.Group>
        </Col>        
        <Col xs={12} md={2} className="d-flex justify-content-center">  
    
          <Form.Group as={Col} className="segbutton">
            <Form.Control name="formSiblingStudyAdd" type="button" className="add btn btn-outline-primary" value="+" onClick={() => addSiblingStudy(index)} />&nbsp;
          </Form.Group>  
          <Form.Group as={Col} className="segbutton">
            <Form.Control name="formSiblingStudyDel" type="button" className="del btn btn-outline-danger" value="-" onClick={() => delSiblingStudy(index)} />
          </Form.Group>  

          </Col>          
        </Form.Row>
        </Fragment>
        ))}   
     
    </Col>
    </Form.Row>
    </div>

    <div className="border p-1 m-2 mb-3">
      <Form.Row>
      <Col xs={12}>        
          <Form.Group as={Col} controlId="formName">
          <Form.Label >If Working</Form.Label>
          </Form.Group>
      </Col>  
      </Form.Row>

    
      <Form.Row className="p-2 Siblings">
      <Col xs={12}>

        <Form.Row className="d-none d-md-flex">
        <Col xs={12} sm={4} className='table-header'>
          <Form.Group as={Col}>
          <Form.Label>Name</Form.Label>
          </Form.Group>
        </Col>
        <Col xs={12} sm={1} className='table-header'>
          <Form.Group as={Col}>
          <Form.Label>Gender</Form.Label>
          </Form.Group>
        </Col>
        <Col xs={12} sm={1} className='table-header'>
          <Form.Group as={Col}>
            <Form.Label>Age</Form.Label>
          </Form.Group>
        </Col>
        <Col xs={12} sm={2} className='table-header'>
          <Form.Group as={Col}>
            <Form.Label>Occupation</Form.Label>
          </Form.Group>
        </Col>
        <Col xs={12} sm={2} className='table-header'>
          <Form.Group as={Col}>
            <Form.Label>Monthly Income (RM)</Form.Label>
          </Form.Group>
        </Col>
        <Col xs={12} sm={2} className='table-header d-flex justify-content-center'>          
          <Form.Group as={Col} className="segbutton">
            <Form.Label>action</Form.Label>
        </Form.Group>
        </Col>        
      </Form.Row> 



        {siblingWorking.map((inputField, index) => (
        <Fragment key={`${inputField}~${index}`}>
        <Form.Row>          
        <Col xs={12} md={4}>
          <Form.Group as={Col} >
            <Form.Label className="d-flex d-md-none">SiblingName</Form.Label>
            <Form.Control name="frNameSiblingWorking" type="text" placeholder="" value={inputField.SiblingName} onChange={event => handleInputChangeWorking('SiblingName', index, event)} />
          </Form.Group>
        </Col>
        <Col xs={12} md={1}>              
          <Form.Group as={Col} >
            <Form.Label className="d-flex d-md-none">Gender</Form.Label>
              <Form.Control name="frGenderSiblingWorking" as="select"   
                value={inputField.Gender}
                onChange={(event) => handleInputChangeWorking('Gender', index, event)} >
                <option key='' value=''></option>  
                <option key='M' value='M'>M</option>
                <option key='F' value='F'>F</option>            
              </Form.Control>
          </Form.Group>
        </Col>
        <Col xs={12} md={1}>
          <Form.Group as={Col}>
            <Form.Label className="d-flex d-md-none">Age</Form.Label>  
            <Form.Control name="frAgeSiblingWorking" type="text" placeholder="" value={inputField.Age} onChange={event => handleInputChangeWorking('Age', index, event)} />
          </Form.Group>  
        </Col>
        <Col xs={12} md={2}>
          <Form.Group as={Col}>
            <Form.Label className="d-flex d-md-none">Occupation</Form.Label>
            <Form.Control name="frOccupationSiblingWorking" type="text" placeholder="" value={inputField.Occupation} onChange={event => handleInputChangeWorking('Occupation', index, event)} />
          </Form.Group>
        </Col>
        <Col xs={12} md={2}>
          <Form.Group as={Col}>
            <Form.Label className="d-flex d-md-none">Monthly Income (RM)</Form.Label>
            <Form.Control name="frIncomeSiblingWorking" type="text" placeholder="" value={inputField.Income} onChange={event => handleInputChangeWorking('Income', index, event)} />
          </Form.Group>
        </Col>        
        <Col xs={12} md={2} className="d-flex justify-content-center">  
 
          <Form.Group as={Col} className="segbutton">
            <Form.Control name="formSiblingWorkingAdd" type="button" className="add btn btn-outline-primary" value="+" onClick={() => addSiblingWorking(index)} />&nbsp;
          </Form.Group>  
          <Form.Group as={Col} className="segbutton">
            <Form.Control name="formSiblingWorkingDel" type="button" className="del btn btn-outline-danger" value="-" onClick={() => delSiblingWorking(index)} />
          </Form.Group>  
          
        </Col>          
        </Form.Row>
        </Fragment>
        ))}   
     
    </Col>
    </Form.Row>
    </div>


    </>  
    );
}